import script from "./Usymbols.vue?vue&type=script&setup=true&lang=js"
export * from "./Usymbols.vue?vue&type=script&setup=true&lang=js"

import "./Usymbols.vue?vue&type=style&index=0&id=105145aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-105145aa"]])

export default __exports__